<template>
  <div class="text-center mt-5 mb-5">
    <i class="bx bx-hourglass bx-spin font-size-16 align-middle mr-2"></i>
    {{ $t("common.loading") }}
  </div>
</template>

<script>
export default {};
</script>
